import {  getTokenLocal, getUserLocal } from "../utils/localStorage.util";

export const useAuthenticated = () => {
  const user = getUserLocal();
  const token = getTokenLocal();
  if (user && token) {
    return true;
  } else {
    return false;
  }
};
